import React from 'react';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import {
    DELIVERY_ALIPAY,
    DELIVERY_BANK_ACCOUNT,
    DELIVERY_BANK_CARD,
    DELIVERY_CASH,
    DELIVERY_HOME,
    DELIVERY_UPI,
    DELIVERY_VIA_PHONE_NUMBER,
    DELIVERY_WALLET,
    DELIVERY_INTERAC,
    DELIVERY_PEOPLE_TRUST_INTERAC,
} from 'apps/auth/constants/Constants';
import { URL_IMAGES_BANKS } from 'apps/auth/constants/UrlConstants';
import { toLowerCase } from 'apps/auth/helpers/utils';

const iconNameObj = {
    [DELIVERY_BANK_CARD]: 'card-48',
    [DELIVERY_VIA_PHONE_NUMBER]: 'mobile-48',
    [DELIVERY_BANK_ACCOUNT]: 'bank-48',
    [DELIVERY_CASH]: 'cash-stack-48',
    [DELIVERY_HOME]: 'cash-stack-48',
    [DELIVERY_UPI]: 'upi-48',
    [DELIVERY_ALIPAY]: 'alipay-48',
    [DELIVERY_WALLET]: 'wallet-48',
    [DELIVERY_INTERAC]: 'interac-48',
    [DELIVERY_PEOPLE_TRUST_INTERAC]: 'bank-48',
};

const PreCheckMainView = (props) => {
    const {
        preCheck: { toBankAlias = '', toBankCountryCode, formatedAmountFrom, formatedAmountTo, amountFromCurrency, amountToCurrency, deliveryMethod },
    } = props;

    const iconName = iconNameObj[deliveryMethod] ?? 'card-48';
    return (
        <>
            <Row indent="adaptive-16-24">
                <DiskBadge
                    diskSize="large"
                    iconName={toBankAlias ? '' : iconName}
                    src={toBankAlias ? `${URL_IMAGES_BANKS}/${toBankAlias}.png` : ''}
                    alt={toBankAlias}
                    flagName={toBankCountryCode}
                />
            </Row>
            <Text variant="div" size="header" indent="adaptive-16-24">
                {`${formatedAmountFrom} `}
                <Text size="header" smallCaps>
                    {toLowerCase(amountFromCurrency)}
                </Text>
                {' → '}
                {`${formatedAmountTo} `}
                <Text size="header" smallCaps>
                    {toLowerCase(amountToCurrency)}
                </Text>
            </Text>
        </>
    );
};
export default PreCheckMainView;
